import React, { ReactNode } from "react";
import { Navigate, useParams } from "react-router-dom";
import { useSections } from "@/lib/sections";
import { useAuth, homeFor } from "@/contexts/AuthContext";

export const VenueRoute = ({ children }: { children: ReactNode }) => {
  const { user } = useAuth();
  const { id } = useParams();
  if (user === null) return null;
  if (user && user.role !== "customer") return <>{children}</>;
  return <Navigate to={`/spots/${id}`} replace />;
};

export const SectionGuard = ({ need, children }: { need: "events" | "spots"; children: ReactNode }) => {
  const s = useSections();
  const { user } = useAuth();
  if (user && user.role !== "customer") return <>{children}</>;
  if (!s.mode || user === null) return null;
  if (!s[need]) return <Navigate to={user ? homeFor(user.role) : "/"} replace />;
  return <>{children}</>;
};
